type SearchParamValue = string | number | boolean;

export const buildUrlWithParam = (
  basePath: string,
  param: string,
  value: SearchParamValue
) => {
  const url = new URL(basePath, window.location.origin);
  url.searchParams.set(param, value.toString());
  return url.toString();
};
